import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { PlankSymbol } from "../components/Logo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="container-hw flex flex-col items-start py-24">
      <Seo title="Page not found | H&W Furniture" description="This page doesn't exist." path="/" noindex />
      <span className="grid h-20 w-20 place-items-center rounded-full bg-sand"><PlankSymbol className="h-10 w-10 text-walnut" /></span>
      <p className="eyebrow mt-8">404</p>
      <h1 className="t-h1 mt-3">This shelf is empty.</h1>
      <p className="t-lead mt-4 max-w-md">The page you're looking for isn't here. Our DIY modular furniture is just a click away.</p>
      <div className="mt-8 flex gap-3">
        <Link to="/product/pustak-rack" data-testid="not-found-shop-button" className="btn-sheesham">Shop the Pustak Rack</Link>
        <Link to="/" data-testid="not-found-home-button" className="btn-outline">Go home</Link>
      </div>
    </div>
  );
}
